var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68784 17.9261C4.74141 17.9261 4.79498 17.9207 4.84855 17.9127L9.35391 17.1225C9.40748 17.1118 9.45837 17.0877 9.49587 17.0475L20.8503 5.69302C20.8752 5.66824 20.8949 5.63881 20.9083 5.60641C20.9218 5.574 20.9287 5.53927 20.9287 5.50419C20.9287 5.4691 20.9218 5.43437 20.9083 5.40196C20.8949 5.36956 20.8752 5.34013 20.8503 5.31535L16.3986 0.860882C16.3477 0.809989 16.2807 0.783203 16.2084 0.783203C16.1361 0.783203 16.0691 0.809989 16.0182 0.860882L4.66373 12.2153C4.62355 12.2555 4.59944 12.3037 4.58873 12.3573L3.79855 16.8627C3.77249 17.0062 3.7818 17.1538 3.82568 17.2929C3.86955 17.432 3.94666 17.5583 4.05033 17.6609C4.22712 17.8323 4.44944 17.9261 4.68784 17.9261ZM6.49319 13.2546L16.2084 3.54213L18.1718 5.50552L8.45659 15.218L6.07534 15.6386L6.49319 13.2546ZM21.3566 20.1761H1.6423C1.16819 20.1761 0.785156 20.5591 0.785156 21.0332V21.9975C0.785156 22.1153 0.881585 22.2118 0.999442 22.2118H21.9994C22.1173 22.2118 22.2137 22.1153 22.2137 21.9975V21.0332C22.2137 20.5591 21.8307 20.1761 21.3566 20.1761Z",
    fill: "#1D8960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.410b13519dc99bcb9c76eded89899e17.svg";
export { ForwardRef as ReactComponent };